export default {
  pageDesc: '以 SKU 为最小单元，记录架位分布、规格与抓取适配状态',
  newDispatch: '+ 新建派单',
  kpiSkuCount: '在库 SKU 数',
  kpiSkuCountSub: 'Top SKU 优先上架',
  kpiGrabOk: '机器人可稳定抓取',
  kpiGrabOkSub: '瓶装 / 盒装标准形状',
  kpiGrabWarn: '待验证 / 暂不适配',
  kpiGrabWarnSub: '片装 / 软包装，需实测',
  kpiAvgWeight: '平均单件重量',
  kpiAvgWeightSub: '上限 10kg',
  unitCount: '个',
  unitKg: 'kg',
  rackTitle: '架位分布',
  rackHint: '10 个货架 · 每架前后两面（A / B）· 每面 5 层 ＝ 5 个架位 · 共 100 个架位；一层两箱，同层可混放多个 SKU',
  rackCodeNotePrefix: '架位编码规则：',
  rackCodeStaticLabel: '静态架位号',
  rackCodeRule: '{架号}{面}-{层}F',
  rackCodeNoteMid: '，例 ',
  rackCodeNoteEx1: ' 表示 1 号货架 A 面第 2 层；',
  rackCodeFullLabel: '完整架位码',
  rackCodeFullMid: ' ＝ 停靠位 + 静态架位号，例 ',
  rackCodeNoteEx2: ' 表示左位那台货架的 A 面第 2 层。箱不参与寻址（一层两箱）；每列自上而下为 5F → 1F。',
  rackFace: '{face} 面',
  rackName: '{id} 号架',
  rackUsed: '{used} / 10',
  slotEmpty: '空架位',
  legendFree: '空架位',
  legendSingle: '单 SKU 架位',
  legendMulti: '混放架位（同层多个 SKU）',
  filterGrab: '抓取适配',
  filterGrabAll: '全部',
  filterForm: '形态',
  filterFormAll: '全部形态',
  formBottle: '瓶装',
  formBox: '盒装',
  formSheet: '片装',
  formSoft: '软包装',
  filterKw: '条码 / SKU / 商品名',
  filterKwPlaceholder: '输入关键词',
  totalCount: '共 {n} 个',
  listTitle: '商品明细',
  listHint: '一个架位可混放多个 SKU；POC 中 139 个 SKU 分布在 100 个架位',
  importSku: '商品SKU导入',
  importSkuTitle: '商品SKU导入',
  importSkuHint: '请选择 Excel 文件（.xlsx / .xls）',
  importSkuSelect: '选择文件',
  importSkuDownloadTemplate: '下载模板',
  importSkuDownloadTemplateFail: '模板下载失败',
  importSkuRequired: '请先选择要导入的文件',
  importSkuInvalidType: '文件格式不正确，请上传 .xlsx 或 .xls 文件',
  importSkuOk: '开始导入',
  importSkuCancel: '取消',
  importSkuSuccess: 'SKU 导入成功',
  importSkuSuccessCount: 'SKU 导入成功，共 {n} 条',
  importSkuPartial: '导入完成：成功 {success} 条，失败 {fail} 条',
  importSkuFail: 'SKU 导入失败',
  colWmsId: 'WmsID',
  colSku: 'SKU',
  colBrand: '品牌',
  colName: '商品名称',
  colForm: '形态',
  colWeight: '重量',
  colDim: '规格（长×宽×高）',
  colGrab: '抓取适配',
  colAction: '操作',
  actionEdit: '修改',
  actionDelete: '删除',
  editTitle: '修改商品',
  editOk: '保存',
  editCancel: '取消',
  editFieldWmsId: 'WmsID',
  editFieldSku: 'SKU',
  editFieldBrand: '品牌',
  editFieldName: '商品名称',
  editFieldForm: '形态',
  editFieldWeight: '重量',
  editFieldDim: '规格（长×宽×高）',
  editPlaceholderWmsId: '请输入 WmsID',
  editPlaceholderSku: '请输入 SKU',
  editPlaceholderBrand: '请输入品牌',
  editPlaceholderName: '请输入商品名称',
  editPlaceholderWeight: '请输入重量',
  editPlaceholderDim: '请输入规格，如 300x200x100',
  editRequired: '请完善必填项',
  editSuccess: '商品修改成功',
  editFail: '商品修改失败',
  deleteConfirmTitle: '确认删除该商品？',
  deleteConfirmContent: '删除后不可恢复，SKU：{sku}',
  deleteConfirmOk: '删除',
  deleteConfirmCancel: '取消',
  deleteSuccess: '商品删除成功',
  deleteFail: '商品删除失败',
  grabOk: '可抓取',
  grabPending: '待验证',
  grabNo: '暂不适配',
  empty: '没有符合条件的商品',
}
